import React from 'react';
import {Typography} from '@bonprix/design-system';

export default function CartItemName({item, onNameClick, itemHeaderComponentSize}) {

    const itemHeaderComponent = "h" + itemHeaderComponentSize;

    return (
        <a
            className='cart-item-details__name'
            href={item.url}
            onClick={onNameClick}
        >
            <Typography variant='h5'
                        color={!item.deliverable ? 'on-bg-mid' : null}
                        strikeThrough={!item.deliverable}
                        component={itemHeaderComponent}>
                {item.productName}
            </Typography>
        </a>
    );
}
